var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.onToggleTheme}},[_c('v-icon',[_vm._v(_vm._s(_vm.$vuetify.theme.dark ? "mdi-brightness-4" : "mdi-brightness-7"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }